module.exports = __webpack_public_path__ + "img/stepError.ef6314ff.png";